import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MentionsLegales from "../pages/mentions-legales/page";
import PolitiqueConfidentialite from "../pages/politique-confidentialite/page";
import VehiclePage from "../pages/vehicle/page";
import VehiclesPage from "../pages/vehicles/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vehicules",
    element: <VehiclesPage />,
  },
  {
    path: "/vehicule/:id",
    element: <VehiclePage />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/politique-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;